import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

/**
 * Returns the `testTarget.offers.updateProductNameDisplayHP` offer object from the offers slice,
 * or `Empty.Object` when that offer is missing.
 */
const updateProductNameDisplayHPSelector = createSelector(testTargetOffersSelector, offers => offers.updateProductNameDisplayHP || Empty.Object);

export { updateProductNameDisplayHPSelector };
